import { scaleLinear } from "d3-scale";
import { interpolateHcl } from "d3-interpolate";
import { rgb } from "d3-color"

function getColorMap(maxValue) {
  return scaleLinear().domain([0, maxValue])
  .interpolate(interpolateHcl)
  .range([rgb("#F5DCDC"), rgb('#ec0000')]);
}

export { getColorMap }
